// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3U4OR","rootSuccess":"CompleteLink_rootSuccess__1fX0I","rootFailure":"CompleteLink_rootFailure__YkMJd","isDisabled":"CompleteLink_isDisabled__2vzGq"};